export const DONUT_RADIUS = 15.91549430918954;
export const DONUT_CENTER = 21;
export const DEFAULT_SEGMENT_GAP = 0.6;
export const DEGREES_PER_PERCENT = 3.6;

export function calculateGapSize(percentage: number, segmentGap: number) {
  return Math.max(0, Math.min(percentage, segmentGap));
}

export function calculateDasharray(percentage: number, segmentGap: number) {
  const gapSize = calculateGapSize(percentage, segmentGap);
  return `${percentage - gapSize} ${100 - percentage + gapSize}`;
}

export function calculateRotation(offset: number, isFirst: boolean) {
  const degrees = isFirst ? 0 : offset * DEGREES_PER_PERCENT;
  return `rotate(${degrees}, ${DONUT_CENTER}, ${DONUT_CENTER})`;
}

export function calculateSegmentOffset(
  segments: { percentage: number }[],
  index: number,
) {
  return segments.reduce((prev, curr, i) => {
    if (i >= index) return prev;

    return prev + curr.percentage;
  }, 0);
}

export function resolveColor(
  color: string | undefined,
  containerEl: HTMLElement | null,
) {
  if (!color || !containerEl) return color;

  if (!color.includes('var(')) return color;

  const el = document.createElement('div');
  el.style.color = color;
  containerEl.appendChild(el);
  const resolved = getComputedStyle(el).color;
  containerEl.removeChild(el);
  return resolved || color;
}
